<template>
    <div id="safe-manager">
      <div class="wrapper">
        <!-- <mainHeader class="mainHeader"></mainHeader> -->
        <img class="security_img" :src="'https://cdn.zxzx119.com/zxzx-h5/other/security02.jpg?v='+Date.now()" alt="" srcset="">
        <!-- <mainFooter class="mainFooter"></mainFooter> -->
      </div>
      <!--  支付弹窗  -->
    </div>
  </template>
  <script>
  
  import mainHeader from '../header'
//   import mainFooter from '../footer'
  
  export default{
    data () {
      return {
        images: [
          ],
      }
    },
    methods: {
      
    },
    components: { // 注册组件
      mainHeader,
    //   mainFooter,
    }
  }
  </script>
  
  <style scoped>
  .wrapper{
    background-color: #F6F6F6;
    width: 100%;
    /* margin-bottom: 70px; */
  }
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
  }
  img{
    width: 100%;
    display: block;
  }
 .security_img{
    /* margin-top: 55px; */
 }
  </style>
  


// WEBPACK FOOTER //
// src/view/activity/security.vue